import { render, staticRenderFns } from "./ClientsStatisticHeaders.vue?vue&type=template&id=c77bd4ec&scoped=true"
import script from "./ClientsStatisticHeaders.vue?vue&type=script&lang=js"
export * from "./ClientsStatisticHeaders.vue?vue&type=script&lang=js"
import style0 from "./ClientsStatisticHeaders.vue?vue&type=style&index=0&id=c77bd4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77bd4ec",
  null
  
)

export default component.exports